import {ActionPropsHolder} from './actionProps';

export type onClose = () => void;

export function close(holder: ActionPropsHolder, onClose?: onClose) {
  if (onClose) {
    onClose();
  }
}
